import React, {
  Component
} from 'react';

export default class ThanksMessage extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
     <div className="success-msg" style={{width:'100%'}}>{this.props.message}</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/partials/ThanksMessage.js